// a wrapper made by once or onDebounce matches only itself; a user's function matches itself and its wrappers
export default function isSameCallback(given, existing) {
  return given._callback ? given === existing : given === (existing._callback || existing);
}
// on() adds no second listener of the same kind: the same function, or a wrapper of the same kind around it
export function isDuplicateCallback(given, existing) {
  return given === existing || !!(given != null && given._callback) && given._callback === (existing == null ? void 0 : existing._callback) && given._kind === existing._kind;
}